import * as React from 'react';

export interface ContentProps {
  dataHook?: string;
  children?: React.ReactNode;
  size?: ContentSize;
}

export type ContentSize = 'medium' | 'large';

export default class Content extends React.PureComponent<ContentProps> {}
